import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import JobService from "../../../Jobs/Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function JobDetail({ InvoiceID }) {
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const navigate = useNavigate();
    const [KeyNameList, setKeyNames] = useState([]);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    useEffect(() => {     
       fetchKeyNames();
    }, [InvoiceID]);
    
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, InvoiceID,"7");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });
            setFormData(initialFormData);
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files[0] // Assuming only one file is uploaded
        }));
    };

    const renderField = (keyItem) => {
        const { TypeName, vc_Name, vc_Description, vc_Value } = keyItem;

        switch (TypeName) {
            case "Text":
                return (
                    <input
                        type="text" 
                        className="form-control col-sm-8"
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                        placeholder={vc_Description || ''}
                    />
                );

            case "Textarea":
                return (
                    <textarea
                        rows={2}
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                    />
                );

            case "Select":
                return (
                    <select
                        name={vc_Name}
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                    >
                        <option value="0">Select an Option</option>
                        {keyItem.options && keyItem.options.map((option) => (
                            <option key={option.ID} value={option.ID}>
                                {option.Name}
                            </option>
                        ))}
                    </select>
                );

            case "Integer":
                return (
                    <input
                        type="text"
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleIntegerChange}
                    />
                );

            case "Decimal":
                return (
                    <input
                        type="text"
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleDecimalChange}
                    />
                );

            case "Currency":
                return (
                    <input
                        type="text"
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleDecimalChange}
                    />
                );

            case "DateTime":
                return (
                    <input
                        type="datetime-local"
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                    />
                );

            case "Formula":
                return (
                    <input
                        type="text"
                        className="form-control col-sm-8"
                       
                        name={vc_Name}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                        placeholder="Enter formula"
                    />
                );

            case "Image":
                return (
                    <input
                        type="file"
                        accept="image/*"
                        className="form-control file-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        onChange={handleFileChange}
                    />
                );

            case "File":
                return (
                    <input
                        type="file"
                        className="form-control file-control col-sm-8"
                        placeholder={vc_Description || ''}
                        name={vc_Name}
                        onChange={handleFileChange}
                    />
                );

            case "Yes/No":
                return (
                    <select
                        name={vc_Name}
                        className="form-control col-sm-8"
                        placeholder={vc_Description || ''}
                        value={formData[vc_Name] || ''}
                        onChange={handleInputChange}
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                );

            default:
                return null;
        }
    };

    const renderFormFields = () => {
        if (KeyNameList.length === 0) {
            return <div>No fields are defined.</div>;
        }

        const rows = [];
        for (let i = 0; i < KeyNameList.length; i += 2) {
            const field1 = KeyNameList[i];
            const field2 = KeyNameList[i + 1];

            rows.push(
                <div className="row mb-3" key={i}>
                    <div className="col-sm-6">
                        {field1 && (
                            <div>
                                <label htmlFor={field1.vc_Name} className="col-sm-4 col-form-label">
                                    {field1.vc_Name}
                                </label>
                                {renderField(field1)}
                                {errors[field1.vc_Name] && (
                                    <div style={{ color: "red", fontSize: "0.8vw" }}>
                                        {errors[field1.vc_Name]}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="col-sm-6">
                        {field2 && (
                            <div>
                                <label htmlFor={field2.vc_Name} className="col-sm-4 col-form-label">
                                    {field2.vc_Name}
                                </label>
                                {renderField(field2)}
                                {errors[field2.vc_Name] && (
                                    <div style={{ color: "red", fontSize: "0.8vw" }}>
                                        {errors[field2.vc_Name]}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return rows;
    };

    const handleSubmitForm = async (e) => {
        e.preventDefault();

        const submissionData = {
            ClientID: formData.ClientID || '',
            UserID: formData.UserID || '',
            JobID: InvoiceID || '',
            fields: KeyNameList.map(keyItem => ({
                PK_KeyName_ID: keyItem.PK_KeyName_ID,
                value: formData[keyItem.vc_Name] || ''
            }))
        };

        const message = await handleSubmit(submissionData);
        if (message.data.message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
    };

    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ textAlign: 'right' }}>
                    <HelpSite FormName="User Define Fields" Module="8" />
                </div>
            </div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}

            <form onSubmit={handleSubmitForm}>

                {renderFormFields()}

                <div className="row" style={{ float: "right" }}>
                    <div className="col-sm-4">
                        {KeyNameList.length > 0 && (
                            <button type="submit" className="btn btn-primary" >
                                <i className="icofont-save" aria-hidden="true">
                                    {InvoiceID > 0 ? ' Update' : ' Add'}
                                </i>
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}

export default JobDetail;
